import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

import type { Widgets } from '@common/enums';

@Component({
    selector: 'web-zero-widget-controls',
    templateUrl: './zero-widget-controls.component.html',
    styleUrls: ['./zero-widget-controls.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [TranslatePipe, TooltipModule, BsDropdownModule],
})
export class ZeroWidgetControlsComponent {
    private DROPDOWN_WIDTH = 220; // aproximated width of the dropdown menu

    @ViewChild('dropdownButton', { read: ElementRef }) dropdownButton!: ElementRef<HTMLButtonElement>;

    @Input() public widgetName: Widgets;
    @Input() public disableCopyEvent: boolean;
    @Input() public disableRemoveEvent: boolean;
    @Input() public selectActionTooltip: string;
    @Input() public disableRemoveEventTooltip: string;

    @Output() public deleteEvent: EventEmitter<void> = new EventEmitter<void>();
    @Output() public copyEvent: EventEmitter<void> = new EventEmitter<void>();
    @Output() public selectEvent: EventEmitter<void> = new EventEmitter<void>();
    @Output() public toggleMoreActionState: EventEmitter<boolean> = new EventEmitter<boolean>();

    public deleteAction(): void {
        this.deleteEvent.emit();
    }

    public copyAction(): void {
        if (this.disableCopyEvent) {
            return;
        }

        this.copyEvent.emit();
    }

    public selectAction(): void {
        this.selectEvent.emit();
    }

    public onOpenDropdown(container): void {
        this.toggleMoreActionState.emit(true);

        const buttonRect = this.dropdownButton.nativeElement.getBoundingClientRect();
        const menuEl = container._element.nativeElement.querySelector('.dropdown-menu') as HTMLElement;

        if (!menuEl) return;

        if (buttonRect.left < this.DROPDOWN_WIDTH) {
            menuEl.style.right = `-${this.DROPDOWN_WIDTH - buttonRect.left}px`;
        }
    }

    public onCloseDropdown(): void {
        this.toggleMoreActionState.emit(false);
    }
}
